var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 8,
    viewBox: "0 0 9 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.82322 0.82713C2.92085 0.729498 3.07915 0.729498 3.17678 0.82713L6.17678 3.82713C6.27441 3.92476 6.27441 4.08305 6.17678 4.18068L3.17678 7.18068C3.07915 7.27831 2.92085 7.27831 2.82322 7.18068C2.72559 7.08305 2.72559 6.92476 2.82322 6.82713L5.64645 4.00391L2.82322 1.18068C2.72559 1.08305 2.72559 0.924761 2.82322 0.82713Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevronRight.7217606e97543eb781729cdb7f9b637e.svg";
export { ForwardRef as ReactComponent };